<template>
  <v-card
    flat
    class="my-3 mx-1"
    style="cursor: pointer;"
    @click="checkOrGoProductDetails(product, $event)"
  >
    <div
      v-lazy-container="{
        error: 'https://konselior.s3.amazonaws.com/media/loading_spinner.gif',
        loading: 'https://konselior.s3.amazonaws.com/media/loading_spinner.gif'
      }"
      class="background-card"
    >
      <v-img
        id="product-image"
        contain
        :src="
          product.mainImage
            ? product.mainImage
            : 'https://konselior.s3.amazonaws.com/media/semImagem.jpg'
        "
        :class="{
          imageResize: $vuetify.breakpoint.mdAndUp,
          'image-style': $vuetify.breakpoint.smAndDown
        }"
        class="product__image"
        @error="product.mainImage = null"
      >
        <div
          v-show="canSelect"
          id="checkbox"
          class="add-product-button ma-2"
        >
          <v-icon
            medium
            :color="productSelectIcon.color"
          >
            {{ productSelectIcon.icon }}
          </v-icon>
        </div>
      </v-img>
    </div>
    <v-layout>
      <v-flex class="product-card-alignment mt-2">
        <h5 class="product__sku">
          {{ product.reference }}
        </h5>
        <h5 class="product__name mt-1">
          <a
            style="text-decoration: none"
            @click="$router.push(`/produtos/${product.idERP}`)"
          >
            {{ product.descricaoCurta }}
          </a>
        </h5>
        <h5 class="product__price mt-1">
          <s v-if="getStoreSkuPrice(product, 'old')">
            {{ getStoreSkuPrice(product, 'old') | currency }}
          </s>
          {{ (getStoreSkuPrice(product, 'regular') || product.preco) | currency }}
        </h5>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    product: {
      type: Object,
      required: true,
    },
    canSelect: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    ...mapGetters(['getStore']),
    productSelectIcon() {
      return {
        icon: this.product.checkbox ? 'mdi-minus-circle' : 'mdi-plus-circle',
        color: this.product.checkbox ? '#FF5146' : '#FFBDE5',
      };
    },
  },
  methods: {
    checkOrGoProductDetails(product, event) {
      if (event.ctrlKey || event.metaKey || event.shiftKey) return;
      if (!this.canSelect) this.$router.push(`/produtos/${product.idERP}`);
      this.$set(product, 'checkbox', !product.checkbox);
    },
    getStoreSkuPrice(product, priceType) {
      const skuByStore = product.skus.find((sku) => sku.idLoja === this.getStore.id && sku.currentStock > 0) || {};

      const prices = {
        old: skuByStore.oldPrice,
        regular: skuByStore.price,
      };

      return prices[priceType];
    },
  },
};
</script>

<style scoped lang="scss">

.add-product-button {
  display: inline-block;
  z-index: 1;
}

.product-card-alignment {
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  text-align: start;
}

.product {
  font-family: 'Nunito Sans';
  font-style: normal;
  font-size: 12px;
  &__sku {
    font-weight: 600;
    line-height: 18px;
    color: #433D4E;
  }
  &__name {
    font-weight: bold;
    line-height: 16px;
    color: #140C22;
  }
  &__price {
    font-size: 16px;
    font-weight: 800;
    line-height: 22px;
    color: #0C4439;
  }
  &__image {
    display: flex;
    justify-content: end;
    align-items: end;
  }
}

::v-deep .v-responsive__content {
  max-width: fit-content;
}

</style>
